import BaseModel from './BaseModel';

class BaasVaasConfig extends BaseModel {
    constructor(data = {}) {
      super(data);
      this.updateData(data);
    }

    updateData = (data) => {
        this.id = data.id;
        this.branch_id = data.branch_id || "";
        this.user_type_id = data.user_type_id || "";
        this.user_ids = data.user_ids || [];
        this.child_service_types = data.child_service_types || [];
    }

    toApiJson = () => {
      this.completeValidation();
      return {
        service_type_user_mappings: this.createServiceTypeUserParams()
      }
    }

    createServiceTypeUserParams = () => {
      let service_type_user_mappings = [];
      this.user_ids.forEach((user_id) => {
        this.child_service_types.forEach((service_type_id)=>{
          service_type_user_mappings.push({user_id: user_id, service_type_id: service_type_id})
        })
      })
      return service_type_user_mappings
    }

    validations = (field) => {
      return {
        branch_id: () => {
          if (this[field] === "") {
            this.errors.branch_id = "Please select circle";
          } else{
            delete this.errors.branch_id;
          }
        },
        user_type_id: () => {
          if (this[field] === "") {
            this.errors.user_type_id = "Please select user type";
          } else{
            delete this.errors.user_type_id;
          }
        },
        user_ids: () => {
          if (this[field].length == 0) {
            this.errors.user_ids = "Please select user";
          } else{
            delete this.errors.user_ids;
          }
        },
        child_service_types: () => {
          if (this[field].length == 0) {
            this.errors.child_service_types = "Please select child service type";
          } else{
            delete this.errors.child_service_types;
          }
        },
      }[field];
    }

    validate = (field) => {
        if (this.validations(field)) {
          this.validations(field)()
        }
    }
}

export default BaasVaasConfig;
